import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { OrganizationDataService } from '../../../core/api-services/organization-data.service';
import { OrganizationTestResult } from '../../../core/response-models/organization-test-result.model';

/**
 * Organization Test Results Tab Component
 *
 * Displays a read-only table of the latest safety test attempt per member per test
 * for an organization. Shows pass/fail status with color-coded badges.
 */
@Component({
  selector: 'app-organization-test-results-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './organization-test-results-tab.component.html',
  styleUrls: ['./organization-test-results-tab.component.scss']
})
export class OrganizationTestResultsTabComponent implements OnInit {
  @Input() organizationId!: string;

  results: OrganizationTestResult[] = [];
  loading = true;
  errorMessage = '';

  constructor(private organizationData: OrganizationDataService) {}

  ngOnInit(): void {
    if (!this.organizationId) {
      this.errorMessage = 'Organization ID is required';
      this.loading = false;
      return;
    }

    this.loadTestResults();
  }

  async loadTestResults(): Promise<void> {
    this.loading = true;
    this.errorMessage = '';

    try {
      this.results = await firstValueFrom(this.organizationData.getTestResults(this.organizationId));
    } catch (error: any) {
      console.error('Failed to load test results:', error);
      this.errorMessage = 'Failed to load test results. Please try again.';
    } finally {
      this.loading = false;
    }
  }

  getMemberName(result: OrganizationTestResult): string {
    const parts = [result.firstName, result.lastName].filter(Boolean);
    return parts.length > 0 ? parts.join(' ') : '-';
  }

  formatDate(date: string | null): string {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
}
